/* Move the existing controls, preserving their native identity and menu desktop pairs. */
(() => {
  if (customElements.get('myart-collection-layout')) return;
  class MyartCollectionLayout extends HTMLElement {
    connectedCallback() {
      if (this.media) return;
      const maxWidth = Number(this.dataset.maxWidth);
      if (!Number.isFinite(maxWidth) || maxWidth < 1) return;
      // Only the collection filter shares its curated order at every width.
      // Header menus retain their existing breakpoint and restore behavior.
      this.allWidths = this.classList.contains('pbn-collection__categories--features');
      this.items = Array.from(this.querySelectorAll('[data-myart-mobile-rank]'))
        .filter((item) => item.closest('myart-collection-layout') === this);
      this.origins = this.items.map((item) => {
        const anchor = document.createComment('myart-collection-origin');
        item.before(anchor);
        return { item, anchor };
      });
      const query = this.dataset.exclusive === 'true' ? `(width < ${maxWidth}px)` : `(max-width: ${maxWidth}px)`;
      this.media = window.matchMedia(query);
      this.onBreakpoint = () => this.arrange();
      this.media.addEventListener('change', this.onBreakpoint);
      this.observer = new ResizeObserver(() => this.scheduleSize());
      this.observer.observe(this);
      this.arrange();
    }

    arrange() {
      const focused = this.contains(document.activeElement) ? document.activeElement : null;
      if (this.allWidths || this.media.matches) {
        const ordered = [...this.items].sort((a, b) => Number(a.dataset.myartMobileRank) - Number(b.dataset.myartMobileRank));
        if (this.allWidths && !this.media.matches) {
          // Stable groups preserve mobile rank within ordinary and special collections.
          const special = ['Famous Artworks', 'AI', 'Artist Designs', 'Mini Kits', 'Diptych', 'Triptych'];
          const priority = (item) => Number(special.includes(item.querySelector('input')?.value));
          ordered.sort((a, b) => priority(a) - priority(b));
        }
        const extras = this.querySelector('.pbn-collection__category-pair--extra');
        for (const item of ordered) this.insertBefore(item, extras);
        this.dataset.mobileReady = 'true';
        this.scheduleSize();
      } else {
        this.restore();
      }
      if (focused?.isConnected && document.activeElement !== focused) focused.focus({ preventScroll: true });
    }

    scheduleSize() {
      cancelAnimationFrame(this.sizeFrame);
      this.sizeFrame = requestAnimationFrame(() => {
        if (!this.isConnected || (!this.allWidths && !this.media?.matches)) return;
        const styles = getComputedStyle(this);
        const row = parseFloat(styles.gridAutoRows);
        const gap = parseFloat(styles.rowGap) || 0;
        if (!Number.isFinite(row) || row <= 0) return;
        for (const item of this.items) {
          if (item.dataset.myartPoster !== 'wide') continue;
          if (this.allWidths && !this.media.matches) {
            item.style.gridRow = 'span 1';
            continue;
          }
          const width = item.getBoundingClientRect().width;
          if (width <= 0) continue;
          const height = width * 235 / 343;
          item.style.gridRow = `span ${Math.max(1, Math.ceil((height + gap) / (row + gap)))}`;
        }
      });
    }

    restore() {
      for (const { item, anchor } of this.origins || []) {
        if (anchor.parentNode) anchor.after(item);
        item.style.removeProperty('grid-row');
      }
      delete this.dataset.mobileReady;
    }

    disconnectedCallback() {
      cancelAnimationFrame(this.sizeFrame);
      this.observer?.disconnect();
      this.media?.removeEventListener('change', this.onBreakpoint);
      this.restore();
      for (const { anchor } of this.origins || []) anchor.remove();
      this.media = null;
      this.observer = null;
      this.items = [];
      this.origins = [];
    }
  }
  customElements.define('myart-collection-layout', MyartCollectionLayout);
})();
